import React, { useState, useRef, useCallback } from 'react';
import './Header.css';
import ThemeSwitcher from '../ThemeSwitcher/ThemeSwitcher';

const LONG_PRESS_MS = 5000;

const Header = ({ onNavigate, onFoundersClick, onApplyNow }) => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [themeSwitcherOpen, setThemeSwitcherOpen] = useState(false);
  const [pressing, setPressing] = useState(false);

  const timerRef = useRef(null);

  const handleNav = (id) => {
    onNavigate(id);
    setMenuOpen(false);
  };

  const handleFounders = () => {
    onFoundersClick();
    setMenuOpen(false);
  };

  // ── Long-press start ──────────────────────────────────────────────────────
  const startPress = useCallback((e) => {
    e.preventDefault();
    setPressing(true);

    timerRef.current = setTimeout(() => {
      setPressing(false);
      //setThemeSwitcherOpen(true);
    }, LONG_PRESS_MS);
  }, []);

  // ── Long-press cancel ─────────────────────────────────────────────────────
  const cancelPress = useCallback(() => {
    clearTimeout(timerRef.current);
    setPressing(false);
  }, []);

  const logoEvents = {
    onMouseDown: startPress,
    onMouseUp: cancelPress,
    onMouseLeave: cancelPress,
    onTouchStart: startPress,
    onTouchEnd: cancelPress,
    onTouchCancel: cancelPress,
    // Prevent the default click-to-reload while pressing
    onClick: () => { if (!pressing) window.location.reload(); },
  };

  return (
    <>
      <header className={`header ${menuOpen ? 'header--open' : ''}`}>

        {/* Top row */}
        <div className="header-top">
          {/* Left: Logo + Brand */}
          <div className="header-left">
            <div
              className={`logo-circle ${pressing ? 'logo-circle--pressing' : ''}`}
              style={{ cursor: 'pointer', userSelect: 'none' }}
              {...logoEvents}
              title="Hold for 5 s to open theme switcher"
            >
              <svg
                className={`logo-progress ${pressing ? 'logo-progress--active' : ''}`}
                viewBox="0 0 56 56"
                aria-hidden="true"
              >
                <circle className="logo-progress__track" cx="28" cy="28" r="26" />
                <circle className="logo-progress__fill" cx="28" cy="28" r="26" />
              </svg>
              <img src="/logos/campus_xl.png" alt="CampusXL logo" className="logo-image" />
            </div>
            <span className="brand-name" onClick={() => window.location.reload()} style={{ cursor: 'pointer' }}>
              CampusXL
            </span>
          </div>

          {/* Right: Nav + Apply Now + Hamburger */}
          <div className="header-right-wrap">
            <button className="header-apply-btn" onClick={onApplyNow}>
              Apply Now
            </button>
            <nav className="header-right">
              <button onClick={() => handleNav('home')} className="nav-link">Home</button>
              <button onClick={() => handleNav('recruiters')} className="nav-link">Placements</button>
              <button onClick={handleFounders} className="nav-link">Founders</button>
              <button onClick={() => handleNav('contact')} className="nav-link">Contact</button>
            </nav>

            <button
              className="hamburger"
              onClick={() => setMenuOpen((o) => !o)}
              aria-label="Toggle menu"
              aria-expanded={menuOpen}
            >
              <span className={`ham-bar ${menuOpen ? 'ham-bar--open-1' : ''}`} />
              <span className={`ham-bar ${menuOpen ? 'ham-bar--open-2' : ''}`} />
              <span className={`ham-bar ${menuOpen ? 'ham-bar--open-3' : ''}`} />
            </button>
          </div>
        </div>

        {/* Mobile dropdown */}
        {menuOpen && (
          <div className="mobile-menu">
            <button onClick={() => handleNav('home')} className="mobile-nav-link">Home</button>
            <button onClick={() => handleNav('recruiters')} className="mobile-nav-link">Placements</button>
            <button onClick={handleFounders} className="mobile-nav-link">Founders</button>
            <button onClick={() => handleNav('contact')} className="mobile-nav-link">Contact</button>
            {/* <button onClick={() => { onApplyNow(); setMenuOpen(false); }} className="mobile-nav-link mobile-nav-link--apply">Apply Now</button> */}
          </div>
        )}
      </header>

      {themeSwitcherOpen && (
        <ThemeSwitcher onClose={() => setThemeSwitcherOpen(false)} />
      )}
    </>
  );
};

export default Header;
